import { useEffect } from 'react';

import { checkVpnStatus, selectVpnStatus } from 'features/vpn-behavior/store';
import { VpnStatus } from 'features/vpn-behavior/enums';
import { useAppDispatch, useAppSelector } from 'features/app/hooks';

/**
 * Checks VPN status on mount and dispatches a detection action if the status is Unknown.
 */
export const useVpnDetection = (): void => {
  const dispatch = useAppDispatch();
  const vpnStatus = useAppSelector(selectVpnStatus);

  useEffect(() => {
    if (vpnStatus === VpnStatus.Unknown) {
      dispatch(checkVpnStatus());
    }
  }, [dispatch, vpnStatus]);
};
